import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SpreadsheetFileFooterIcon = (props: IconProps) => (
  <Icon width="14px" height="20px" viewBox="0 0 14 20" {...props}>
    <path d="M10.939 20H2.97a2.913 2.913 0 0 1-2.099-.91A3.177 3.177 0 0 1 0 16.9V3.305A3.384 3.384 0 0 1 .928.969 3.103 3.103 0 0 1 3.165 0h5.31c.159 0 .312.066.424.184a.641.641 0 0 1 .176.443v4.045c0 .045.018.088.05.12.03.032.072.05.115.05h3.872c.238 0 .466.1.634.276a.962.962 0 0 1 .263.662v11.024c0 .42-.08.837-.235 1.225-.154.388-.38.74-.666 1.037a3.058 3.058 0 0 1-.995.692 2.95 2.95 0 0 1-1.174.242ZM3.165.956a2.207 2.207 0 0 0-1.59.689 2.407 2.407 0 0 0-.66 1.66V16.9c.001.568.218 1.114.604 1.516.385.402.908.628 1.452.628h7.968c.569 0 1.114-.236 1.517-.657.402-.42.628-.989.629-1.583V5.798H9.24c-.286 0-.56-.119-.763-.33a1.153 1.153 0 0 1-.317-.796V.956H3.165Z" />
    <path d="m8.89.173-.64.683 4.855 4.954.64-.683L8.89.173Z" />
    <rect width="2.333" height="1" x="2.8" y="9" rx=".5" />
    <rect width="2.333" height="1" x="2.8" y="11" rx=".5" />
    <rect width="2.333" height="1" x="2.8" y="13" rx=".5" />
    <rect width="2.333" height="1" x="5.6" y="9" rx=".5" />
    <rect width="2.333" height="1" x="5.6" y="11" rx=".5" />
    <rect width="2.333" height="1" x="5.6" y="13" rx=".5" />
    <rect width="2.333" height="1" x="8.4" y="9" rx=".5" />
    <rect width="2.333" height="1" x="8.4" y="11" rx=".5" />
    <rect width="2.333" height="1" x="8.4" y="13" rx=".5" />
  </Icon>
);

export default memo(SpreadsheetFileFooterIcon);
